export const locale = {
    lang: 'en',
    data: {
        HEADER: {
            'LOGIN': 'Log in',
            'APPLICATION': 'Apps',
            'PROFILE': 'Profile',
            'SETTINGS': 'Settings',
            'LOGOUT': 'Logout',
        },
        FOOTER: {
            'ALL_RIGHTS_RESERVED': 'All rights reserved',
        }
    }
};
